import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "./auth";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AppShell from "./pages/AppShell";
import SuperAdmin from "./pages/SuperAdmin";
import Driver from "./pages/Driver";
import Home from "./pages/Home";
import Legal from "./pages/Legal";
import { WhatsAppHelp } from "./components/WhatsAppHelp";
import "./components/WhatsAppHelp.css";

function Loading() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f2f7fb" }}>
      <div style={{ textAlign: "center" }}>
        <img src="/rotasaude-logo.png" alt="RotaSaúde" style={{ width: 150, marginBottom: 12 }} />
        <p style={{ color: "#6d8094" }}>Carregando…</p>
      </div>
    </div>
  );
}

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Home />;
  if (user.role === "superadmin") return <Navigate to="/admin" replace />;
  return <AppShell />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<Protected roles={["superadmin"]}><SuperAdmin /></Protected>} />
        <Route path="/motorista/:token" element={<Driver />} />
        <Route path="/privacidade" element={<Legal doc="privacidade" />} />
        <Route path="/termos" element={<Legal doc="termos" />} />
        <Route path="/confidencialidade" element={<Legal doc="confidencialidade" />} />
        <Route path="/cookies" element={<Legal doc="cookies" />} />
        <Route path="/" element={<RootRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <WhatsAppHelp />
    </BrowserRouter>
  );
}
